



















































import {
  defineComponent,
  reactive,
  onMounted,
  ref,
  computed,
} from '@vue/composition-api';
import _ from 'lodash';

import tableOption from '@/table/Supplier/listTable';
import {
  getSuppliers,
  deleteSupplier,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithPartnerInfo from '@/components/Customer/CommonModalWithPartnerInfo.vue';

const SupplierList = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonModalWithPartnerInfo,
  },
  setup() {
    const refetchQuery = ref(false);
    const deleteSupplierModal = ref(null);
    const partnerInfoModal = ref(null);
    function rowClickHandler(row: any) {
      (partnerInfoModal.value as any).compose(row.item.id, 'SUPPLIER');
    }
    const filter = reactive({
      searchString: '',
    });
    // const computedFilter = computed(() => ({
    //   searchString: filter.searchString !== '' ? `${filter.searchString}` : '',
    // }));

    async function getStats() {
      // detail.name = await getSuppliers();
    }

    const refetchQueryHandler = _.debounce(() => {
      refetchQuery.value = true;
    }, 250);

    onMounted(async () => {
      // await getStats();
    });

    function openDeleteSupplierModal(id: number) { (deleteSupplierModal.value as any).compose({ id }); }
    async function deleteSupplierAction(id: number) { await deleteSupplier(id); refetchQuery.value = true; }

    return {
      tableOption,
      getSuppliers,
      filter,
      // computedFilter,
      refetchQuery,
      refetchQueryHandler,

      deleteSupplierModal,
      openDeleteSupplierModal,
      deleteSupplierAction,

      partnerInfoModal,
      rowClickHandler,
    };
  },
});

export default SupplierList;
